export default "/static/webpack/media/ebber-logo.01ab2d3b.svg";